import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const ContactsLastNameWUT = (props)=>{
    const fieldType = FIELD_TYPES.CONTACTS_LAST_NAME;
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=contacts-last-name-wut.js.map